import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminRecordedSchema } from "./common.js";
/** Where new accounts get to, and where they stop. */
export const adminOnboardingSchema = z.object({
    funnel: z.array(z.object({ key: z.string(), label: z.string(), count: adminCountSchema })),
    signups: z.array(z.object({ weekStart: adminDaySchema, count: adminCountSchema })),
    invites: z.object({
        sent: adminCountSchema,
        accepted: adminCountSchema,
        expired: adminCountSchema,
        revoked: adminCountSchema,
    }),
    signupMethods: adminRecordedSchema(z.array(z.object({
        method: z.enum(["google", "invite", "password", "magic_link"]),
        count: adminCountSchema,
    }))),
    stuck: z.array(z.object({
        workspaceId: z.string(),
        name: z.string(),
        ownerEmail: z.string(),
        step: z.string(),
        daysStuck: adminCountSchema,
    })),
});
//# sourceMappingURL=onboarding.js.map